<div class="browser-update-container">
  <div class="browser-update">
    <h1>
      <label id="lblUpdateBrowser">Please update your browser</label>
    </h1>
    <div class="browser-images">
      <ul>
        <li>
          <img src="/assets/images/browser-icons/icon-IExplorer.png" width="90" height="90" alt="Icon Internet Explorer" /><br
          /> iExplorer
        </li>
        <li>
          <img src="/assets/images/browser-icons/icon-Chrome.png" width="90" height="90" alt="Icon Chrome" /><br /> Chrome
        </li>
        <li>
          <img src="/assets/images/browser-icons/icon-Firefox.png" width="90" height="90" alt="Icon Firefox" /><br /> Firefox
        </li>
        <li>
          <img src="/assets/images/browser-icons/icon-Safari.png" width="90" height="90" alt="Icon Safari" /><br /> Safari
        </li>
        <li>
          <img src="/assets/images/browser-icons/icon-Opera.png" width="90" height="90" alt="Icon Opera" /><br /> Opera
        </li>
      </ul>
    </div>
    <div class="message">
      <h2>
        <label id="lblVersionSystem">
                    If your operating system is Microsoft Windows XP (or older):
                </label>
      </h2>
      <p>
        <strong>
                    <label id="lblInternetExplorer">
                        You can not upgrade the Internet Explorer browser.
                    </label>
                </strong>
      </p>
      <p>
        <label id="lblOptions">
                    The alternatives are:
                </label>
      </p>
      <ol>
        <li>
          <label id="lblUpdateSystem">
                        1. Upgrade the operating system
                    </label>
        </li>
        <li>
          <label id="lblDownloadBrowser">
                        2. Download another browser (Google Chrome recomended)
                    </label>
        </li>
      </ol>
    </div>
  </div>
</div>